import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData('values'))
        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings 
        Vue.config.devtools = true
        
        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default)
        const { required, email } = window.validators

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
    
            el: this.el,

            delimiters: ['${', '}'],

            data: () => {
                return {
                    submitStatus: '',
                    lastname: "",
                    firstname: "",
                    email: '',
                    region: "",
                    condition: ''
                }
            },

            validations: {
                lastname: {
                    required,
                },
                firstname: {
                    required,
                },
                email: {
                    required,
                    email
                },
                region: {
                    required,
                },
                condition: {
                    required
                }
            },

            created() {
                this.moduleInstance = moduleInstance
                // Set initial values
                this.moduleInstance.initialValues && this.setInitialValues(this.moduleInstance.initialValues)
            },

            methods: {
                submit(e) {
                    e.preventDefault()

                    this.$v.$touch();

                    // Scroll to invalid field
                    if (this.$v.$invalid) {
                        this.$nextTick(() => {
                            const getInvalidFields = this.$el.querySelectorAll('.c-form_item.is-invalid')
                            if (getInvalidFields.length) {
                                this.moduleInstance && this.moduleInstance.call('scrollTo', [getInvalidFields[0]], 'Scroll')
                            }
                        })
                        return
                    }

                    // Call Ajax
                    const myPromise = new Promise((resolve) => {
                        // Pending status
                        this.submitStatus = "pending";

                        // Resolve
                        setTimeout(() => {
                            resolve(false)
                        }, 2000)
                    })

                    myPromise.then((response) => {
                        // If succeed
                        if (response) {
                            this.submitStatus = ""
                            let redirectUrl = '/feedback-generic'
                            //this.moduleInstance.call('goTo', {'url': redirectUrl}, 'Load')
                        
                        // If error
                        } else {
                            this.submitStatus = "error";
                            this.moduleInstance && this.moduleInstance.call('scrollTo', [this.$el], 'Scroll')
                        }
                    })
                },
                setInitialValues(values) {
                    const objKeys = Object.keys(values)
                    const objValues = Object.values(values)
                    objKeys.forEach((objKey, index) => {
                        if (this[objKey] != undefined) {
                            this[objKey] = objValues[index]
                        }
                    })
                }
            }
        })
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
